<template>
	<div
		class="d-flex justify-center align-center pa-md-10 chat-container"
		:style="computedStyles"
	>
		<div class="chat-frame">
			<div class="chat-header">
				<ChatHeader />
			</div>
			<ChatBody />
			<v-snackbar v-model="snackbar.show" timeout="2000">
				{{ snackbar.text }}
				<template v-slot:action="{ attrs }">
					<v-btn
						class="button-rounding"
						color="info"
						icon
						v-bind="attrs"
						@click="snackbar.show = false"
					>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</template>
			</v-snackbar>
			<div class="chat-input">
				<ChatInput />
				<div class="progress-bar-container">
					<span class="progress-bar" :style="{ width: progress + '%' }"></span>
					<!-- <span class="progress-percent">{{ progress }}%</span> -->
				</div>
				<div class="power-by-tu-botones">
					<a href="https://www.tubotones.com" target="_blank">
						<!-- <span> Tienda ⚡️ por</span> -->
						<logo-botones/>
					</a>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
// ESTRUCTURA DEL CHAT
// UNIFICACION DE TODOS LOS COMPONENTES
import ChatHeader from "./header";
import ChatBody from "./body";
import ChatInput from "./write_zone";
import LogoBotones from './LogoBotones';
export default {
	components: {
		ChatHeader,
		ChatBody,
		ChatInput,
		LogoBotones
	},
	data: () => ({
		dialog: true,
	}),
	mounted() {
		window.scrollTo(0, 1);
		let vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty("--vh", `${vh}px`);
		document.addEventListener("resize", () => {
			let vh = window.innerHeight * 0.01;
			document.documentElement.style.setProperty("--vh", `${vh}px`);
		});
	},
	computed: {
		computedStyles() {
			return this.$store.getters["chatStore/getAppStyles"];
		},
		loading() {
			return this.$store.getters["store_chat/get_request_status"];
		},
		progress() {
			return this.$store.getters["chatStore/get_progress"];
		},
		snackbar() {
			let network = this.$store.getters["chatStore/get_network_error"];
			let add_to_cart = this.$store.getters[
				"chatStore/get_add_to_cart_snackbar"
			];
			if (network.show) {
				return network;
			}
			return add_to_cart;
		},
	},
	methods: {},
};
</script>
<style lang="scss">
@import "src/styles/variables.scss";
.bot-btn-action {
	background-color: var(--app-button) !important;
	color: var(--app-button-text) !important;
}
.chat-container {
	font-family: "Lato";
}
.chat-container::before {
	font-family: "Lato";
	content: "";
	width: 100%;
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	background-color: var(--main-bg);
	// @include botones-bg(var(--main-bg-detail));
	background-repeat: repeat;
	background-size: 200px 200px;
}
.chat-frame {
	width: 90%;
	max-width: 768px;
	position: fixed;
	top: 0;
	bottom: 0;

	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: stretch;
	.chat-body {
		overflow-y: scroll;
		margin: 0;
		padding: 20px 10px 0 10px;
		flex-grow: 1;
	}
	.chat-body > * {
		max-width: 70%;
	}
	.chat-input {
		background-color: var(--primary-color);
		padding: 4px 10px 0 10px;
	}
}
@media (max-width: 600px) {
	.chat-frame {
		.chat-body > * {
			max-width: 95%;
		}
	}
}
.power-by-tu-botones {
	* {
		fill: var(--secondary-color);
	}
	a {
		display: flex;
	}
	img {
		height: 12px;
		width: auto;
		margin: 3px auto;
	}
}
.progress-bar-container {
	margin-top: 7px;
	margin-left: 30px;
	margin-right: 39px;
	margin-bottom: 0;
	border: 1px solid var(--secondary-color);
	display: flex;
	justify-content: center;
	align-items: center;
	position: relative;
	border-radius: 15px;
	color: white;
	background-color: var(--main-bg-color);
	overflow: hidden;
	height: 10px;
}
.progress-bar {
	border-radius: 15px;
	height: 100%;
	position: absolute;
	left: 0;
	background-color: var(--secondary-color);
}
.progress-percent {
	z-index: 1;
	font-size: 10px;
}
@media (max-width: 900px) {
	.chat-frame {
		position: absolute;
		height: 100%;
		width: 100%;
		.chat-body {
			overflow-y: scroll;
			margin: 0;
		}
	}
}
</style>
